module.exports = __webpack_public_path__ + "static/media/noData.96ef6afc.png";